import { Link } from "react-router-dom";

/**
 * Minimalist MUConcierge wordmark.
 * - Compact serif "M" with a small "U" inset (monogram-style)
 * - Hairline accent line under the wordmark
 * - Fully responsive, ARIA-labelled
 */
export const Logo = ({ to = "/", compact = false }) => {
  return (
    <Link
      to={to}
      className="group inline-flex items-center gap-2.5 shrink-0"
      data-testid="logo-link"
      aria-label="MUConcierge — go to home"
    >
      <span className="relative inline-flex items-center justify-center w-9 h-9 bg-[#1C3326] text-[#FAF9F6] transition-colors group-hover:bg-[#2A4A38]" aria-hidden="true">
        <svg viewBox="0 0 32 32" className="w-5 h-5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5 25 V8 L11 18 L16 9 L21 18 L27 8 V25"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="square"
            strokeLinejoin="miter"
            fill="none"
          />
          <line x1="5" y1="27.5" x2="27" y2="27.5" stroke="#E8C9B6" strokeWidth="1.2" />
        </svg>
      </span>
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className="font-serif text-[1.25rem] tracking-tight text-[#1A201C] transition-colors group-hover:text-[#1C3326]">
            MUConcierge
          </span>
          <span className="tag-line text-[10px] text-[#C26D5C] mt-1 hidden sm:inline-block">Munich · Move-In Concierge</span>
        </span>
      )}
    </Link>
  );
};
